export enum AspectRatio {
  "0:0" = "0:0",
  "16:9" = "16:9",
  "4:5" = "4:5",
  "2:3" = "2:3",
  "1:1" = "1:1",
  "1:2" = "1:2",

  // Named aspect ratios are an alternative for those apps (like filminweb)
  // that prefer to be semantic when refering to aspect ratios
  MediaKeyArt = "16:9",
  MediaHighlighted = "16:9",
  MediaHighlightedVertical = "4:5",
  MediaPosterArt = "2:3",
  MediaKeyFrame = "16:9",
  MediaCoverArt = "16:9",
  MediaSingleColorLogo = "0:0",
  MediaFullColorLogo = "0:0",
  MediaSerieSquareCover = "1:1",

  CollectionHighlighted = "16:9",
  CollectionCoverArt = "16:9",
  CollectionSingleColorLogo = "0:0",
  CollectionMultiColorLogo = "0:0",
  CollectionSquareCover = "1:1",

  ChannelSingleColorLogo = "0:0",
  ChannelMultiColorLogo = "0:0",
  ChannelHighlighted = "16:9",
  ChannelCoverArt = "16:9",
  ChannelSquareCover = "1:1",

  WildcardCoverArt = "16:9",
  WildcardHighlighted = "16:9",
  WildcardSquareCover = "1:1",
  WildcardVerticalCoverArt = "1:2",

  StaffSquarePhoto = "1:1",
  // ActorSquarePhoto = "1:1", DirectorSquarePhoto = "1:1", CharacterSquarePhoto = "1:1",

  MinisiteBackground = "16:9",
  MinisiteSquareCover = "1:1",

  UserAvatar = "1:1",
}

export function isValidAspectRatio(
  aspectRatio: string
): aspectRatio is AspectRatio {
  return Object.values(AspectRatio).includes(aspectRatio as any);
}

/**
 * Receives any string in the "n:n" format (n = number), and returns
 * the closest matching AspectRatio defined.
 */
export function getClosestAspectRatio(aspectRatio: string): AspectRatio {
  const parseRatio = (ratio: string): number => {
    const [w, h] = ratio.split(":").map(Number) as [number, number];
    if (w === 0 || h === 0) {
      return 0;
    }
    return w / h;
  };

  const ratio = parseRatio(aspectRatio);

  if (ratio === 0) {
    return AspectRatio["0:0"];
  }

  // Find the closest matching aspect ratio
  type AspectRatioKey = keyof typeof AspectRatio;
  const closestMatch = (Object.keys(AspectRatio) as AspectRatioKey[]).reduce(
    (aspectRatioA, aspectRatioB) => {
      const ratioA = parseRatio(aspectRatioA);
      const ratioB = parseRatio(aspectRatioB);
      return Math.abs(ratioB - ratio) < Math.abs(ratioA - ratio)
        ? aspectRatioB
        : aspectRatioA;
    },
    "0:0" as AspectRatioKey
  );

  return AspectRatio[closestMatch];
}
